module.exports = __webpack_public_path__ + "static/media/ico-delete-red.aa58a5f7.svg";